import { render, staticRenderFns } from "./SettingOrder.vue?vue&type=template&id=b71467c0&"
import script from "./SettingOrder.vue?vue&type=script&lang=ts&"
export * from "./SettingOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports